import tokenData from '../../design-tokens/base-tokens.json';
export const MuiCard = {
    variants: [
        {
            props: { variant: 'callout' },
            style: {
                background: tokenData.tokens.palette.grey.grey100,
                border: `1px solid ${tokenData.tokens.palette.grey.grey200}`,
                alignItems: 'flex-start',
                boxShadow: 'none',
                '& .MuiCardHeader-avatar': {
                    marginRight: 8
                },
                '& .MuiSvgIcon-root': {
                    color: tokenData.tokens.palette.blue.blue500
                }
            }
        },
        {
            props: { variant: 'callout', color: 'primary' },
            style: {
                background: tokenData.tokens.palette.blue.blue100,
                border: `1px solid ${tokenData.tokens.palette.blue.blue200}`,
                '& .MuiSvgIcon-root': {
                    color: tokenData.tokens.palette.blue.blue500
                },
                '& .MuiCardHeader-avatar': {
                    marginRight: 8
                }
            }
        },
        {
            props: { variant: 'callout', color: 'info' },
            style: {
                background: tokenData.tokens.palette.purple.purple100,
                border: `1px solid ${tokenData.tokens.palette.purple.purple200}`,
                '& .MuiSvgIcon-root': {
                    color: tokenData.tokens.palette.purple.purple500
                },
                '& .MuiCardHeader-avatar': {
                    marginRight: 8
                }
            }
        }
    ],
    styleOverrides: {
        root: {
            color: tokenData.tokens.palette.text.text300,
            boxShadow: '0px 1px 5px 0px #0000001F, 0px 2px 2px 0px #00000024, 0px 3px 1px -2px #00000033',
            '&.MuiPaper-outlined': {
                border: `1px solid ${tokenData.tokens.palette.grey.grey300}`,
                boxShadow: 'none'
            },
            '&.MuiPaper-callout': {
                '& ul': {
                    paddingInlineStart: 56,
                    '&:last-of-type': {
                        marginBottom: 0
                    }
                }
            }
        }
    }
};
export const MuiCardContent = {
    styleOverrides: {
        root: ({ theme }) => ({
            padding: theme.spacing(2, 6, 4, 6),
            '&:last-of-type': {
                paddingBottom: theme.spacing(4)
            }
        })
    }
};
export const MuiCardActions = {
    defaultProps: {
        disableSpacing: true
    },
    styleOverrides: {
        root: ({ theme }) => ({
            background: tokenData.tokens.palette.background.linen,
            borderTop: `1px solid ${tokenData.tokens.palette.grey.grey200}`,
            padding: theme.spacing(4)
        })
    }
};
export const MuiCardMedia = {
    styleOverrides: {
        root: {
            backgroundRepeat: 'no-repeat'
        }
    }
};
export const MuiCardHeader = {
    styleOverrides: {
        root: ({ theme }) => ({
            padding: theme.spacing(4, 6, 2, 6),
            paddingBottom: 8,
            '& + .MuiCardContent-root': {
                paddingTop: 0
            }
        }),
        content: {
            fontWeight: 600,
            color: tokenData.tokens.palette.text.text300
        }
    }
};
export const MuiCardActionArea = {
    styleOverrides: {
        root: {
            '&.Mui-focusVisible': {
                outlineOffset: '-2px',
                outlineStyle: 'solid',
                outlineWidth: '2px',
                outlineColor: tokenData.tokens.palette.text.text300,
                overflow: 'visible'
            }
        }
    }
};
